<script>
import useTools from "@/use/Tools.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useSharedData from "@/use/SharedData.js";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    name: "ValidationTimelines",
    setup() {
        const {$route} = useTools();
        const {dialog, loading} = useSharedData();
        const {getBack, formatedDate} = useSharedMethod();

        const timelines = ref([]);

        function findAll() {
            loading.value = true;
            axios.get(`/validationTimelines/${$route.params.module}/${$route.params.id}`)
                .then(response => {
                    timelines.value = response.data;
                })
                .finally(() => {
                    loading.value = false;
                });
        }

        function downloadFileById(id, fileFullName) {
            axios.get(`/validationTimelines/download/${id}`, {responseType: 'blob'})
                .then(response => {
                    const url = URL.createObjectURL(response.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileFullName;
                    link.click();
                    // Revoke the temporary URL to free up memory
                    URL.revokeObjectURL(url);
                });
        }

        function getColor(timeline) {
            if (timeline.dateValidation) {
                switch (timeline.validationOption) {
                    case 'ACCEPT':
                        return 'teal';
                    case 'REFUSE':
                        return 'red';
                    case 'DELEGATE':
                        return 'purple';
                    case 'KEEP':
                        return 'orange';

                }
            } else {
                return 'cyan';
            }
        }

        onMounted(() => findAll());

        return {
            dialog,
            loading,
            timelines,
            getBack,
            getColor,
            formatedDate,
            downloadFileById,
        }
    },
}
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="1200"
        scrollable
    >
        <v-card>
            <w-toolbar color="teal" :title="$t('common.validation_history')"/>
            <v-card-text>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-left"> {{ $t("common.validation_date") }}</th>
                            <th class="text-left"> {{ $t("common.state") }}</th>
                            <th class="text-left"> {{ $t("common.validator") }}</th>
                            <th class="text-left"> {{ $t("common.description") }}</th>
                            <th class="text-left"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="(timeline, index) in timelines"
                            :key="index"
                        >
                            <td class="text-left">
                                <w-chip :text="formatedDate(timeline.dateValidation)"/>
                            </td>
                            <td class="text-left">
                                <w-inline-text bold :text="timeline.step"/>
                            </td>
                            <td class="text-left">
                                <w-inline-text :text="timeline.validatorFullName ? timeline.validatorFullName : timeline.validator"/>
                            </td>
                            <td class="text-left">{{ timeline.observation }}</td>
                            <td class="text-left">
                                <v-btn
                                    v-if="timeline.fileAttached"
                                    icon
                                    color="blue"
                                    @click="downloadFileById(timeline.id, timeline.fileFullName)">
                                    <v-icon>mdi-paperclip</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close :loading="loading" @press="getBack"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>